<template>
  <v-card>
    <v-card-title class="text-center" style="white-space: nowrap">
      <v-tooltip top color="secondary">
        <template v-slot:activator="{ on }" >
          <v-icon color="orange" v-on="on" class="mr-2">warning</v-icon>
          Manage user permissions
        </template>
        <span>Once you tick or untick the permission the result will have effect immediately</span>
      </v-tooltip>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
      <v-container container--fluid grid-list-md v-if="renderedRegions">
         <v-row justify="center">
          <v-col cols="12">
            <v-select
              :items="renderedRegions"
              v-model="region"
              return-object
              item-text="name"
              label="Region..."
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-card>
              <v-list v-if="region" scrollable style="height: 400px; overflow: scroll">
                <v-list-item
                  v-for="(permission, index) in userPermissionsId"
                  v-if="!permission.global_only || region.id === 0"
                  :key="index"
                >
                  <v-list-item-action>
                    <v-checkbox @change="tickOrUntickPermission(permission)" v-model="permission.selected"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-title>{{permission.display}}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
         </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  import axios from 'axios'

  // @vuese
  // Card used to manage the users' permissions.
  // @group Manage Users
  export default {
    props: {
      user: Object,
      userPermission: Array,
      regions: Array,
      allPermissions: Array,
    },
    name: "ManagePermissions",
    data() {
      return {
        region: null,
        permission: null,
      }
    },
    methods: {
      // @vuese
      // Calls the right API endpoint for ticking/unticking a permission.
      // @arg Takes a permission Object as an argument.
      tickOrUntickPermission(item) {
        if (item.selected) {
          // Tick
          axios.post(process.env.API_URL + '/users/' + this.user.id + '/permissions/' + item.id
            + '/regions/' + this.region.id, item)
            .then((response) => {
            })
            .catch((error) => {
              item.selected = !item.selected;
                this.$store.commit('displaySnackbar', 'ERROR: ' + (error.response.data === undefined ? 'Undefined' : error.response.data.error));
            })
        } else {
          // Untick
          axios.delete(process.env.API_URL + '/users/' + this.user.id + '/permissions/' + item.id
            + '/regions/' + this.region.id, item)
            .then((response) => {
            })
            .catch((error) => {
              item.selected = !item.selected;
                this.$store.commit('displaySnackbar', 'ERROR: ' + (error.response === undefined ? 'Undefined' : error.response.data.error));
            })
        }
      }
    },
    computed: {
      renderedRegions() {
        let regions = this.regions;
        regions.unshift({id: 0, name: 'Global'});
        return regions;
      },
      isInternalUser() {
        return this.user.client_id === 0;
      },
      // @vuese
      // Returns an Array of permission Objects with permission filtered by the region selected. We also added on each permission
      // Object a selected field for the permission checkboxes.
      userPermissionsId() {
        console.log("Render Permissions");
        let userPermissions = [];
        let globalPermissions = [];
        if (this.userPermission.length > 0) {
          userPermissions = this.userPermission.filter((region) => {
            if (this.region.id !== 0) {
              // Region Permissions
              // Hide global permissions
              return parseInt(region.region_id) === this.region.id

            } else {
              //   // Global
              return parseInt(region.region_id) === this.region.id
            }
          });

          globalPermissions = this.userPermission.filter((region) => {
            return parseInt(region.region_id) === 0
          })
        }

        let permissionsID = [];
        if (userPermissions.length > 0) {
          for (let i = 0; i < userPermissions[0].permissions.length; i++) {
            permissionsID.push(userPermissions[0].permissions[i].id)
          }
        }

        let globalPermissionID = [];
        if (globalPermissions.length > 0) {
          for (let i = 0; i < globalPermissions[0].permissions.length; i++) {
            globalPermissionID.push(globalPermissions[0].permissions[i].id)
          }
        }

        let selected = [];

        for (var j = 0; j < this.allPermissions.length; j++) {
          if (this.region.id === 0) {
            // Global tab --> display all permissions
            let item = Object.assign({}, this.allPermissions[j]);
            if ((item.becool_only && !this.isInternalUser) || (item.client_only && this.isInternalUser)) continue;
            item.selected = permissionsID.includes(this.allPermissions[j].id);
            selected.push(item);
          } else {
            // Region tab --> Hide global permissions
            if (!globalPermissionID.includes(this.allPermissions[j].id)) {
              let item = Object.assign({}, this.allPermissions[j]);
              item.selected = permissionsID.includes(this.allPermissions[j].id);
              selected.push(item);
            }
          }
        }
        return selected
      },

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/ManageUsers/ManagePermissions.vue